import {ReactNode} from "react";

import {Highlight} from "@pg-design/text-module";

export enum AuthModalVariant {
    DEFAULT,
    FAVORITE,
    HIDDEN_PRICES
}

export interface IAuthModalHeaderContent {
    title: ReactNode;
    description: ReactNode;
}

export const getAuthModalHeaderContent = (variant: AuthModalVariant): IAuthModalHeaderContent => {
    switch (variant) {
        case AuthModalVariant.FAVORITE:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>obserwować oferty</Highlight>
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach."
            };

        case AuthModalVariant.HIDDEN_PRICES:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>odkryć ceny</Highlight>
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach"
            };

        case AuthModalVariant.DEFAULT:
        default:
            return {
                title: null,
                description: null
            };
    }
};
import {ReactNode} from "react";

import {Highlight} from "@pg-design/text-module";

export enum AuthModalVariant {
    DEFAULT,
    FAVORITE,
    HIDDEN_PRICES
}

export interface IAuthModalHeaderContent {
    title: ReactNode;
    description: ReactNode;
}

export const getAuthModalHeaderContent = (variant: AuthModalVariant): IAuthModalHeaderContent => {
    switch (variant) {
        case AuthModalVariant.FAVORITE:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>obserwować oferty</Highlight>
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach."
            };

        case AuthModalVariant.HIDDEN_PRICES:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>odkryć ceny</Highlight>
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach"
            };

        case AuthModalVariant.DEFAULT:
        default:
            return {
                title: null,
                description: null
            };
    }
};
